import { BigNumber } from "@ethersproject/bignumber";
import { ethers, BigNumber as EthersBigNumber } from "ethers";
import currency from "currency.js";
import { getDefaultSignificantDecimalsFromAssetDecimals } from "./asset";
var formatUnits = ethers.utils.formatUnits;
export var formatSignificantDecimals = function (num, significantDecimals) {
    if (significantDecimals === void 0) { significantDecimals = 6; }
    return parseFloat(parseFloat(num).toFixed(significantDecimals)).toString();
};
export var formatBigNumber = function (num, decimals, significantDecimals) {
    if (decimals === void 0) { decimals = 18; }
    var _significantDecimals = significantDecimals ||
        getDefaultSignificantDecimalsFromAssetDecimals(decimals);
    return parseFloat(formatUnits(num, decimals)).toLocaleString(undefined, {
        maximumFractionDigits: _significantDecimals,
    });
};
export var toFiat = function (etherVal) {
    var scaleFactor = ethers.BigNumber.from(10).pow("6");
    var scaled = etherVal.div(scaleFactor);
    return scaled.toNumber() / Math.pow(10, 2);
};
export var toUSD = function (bn) {
    return Math.floor(parseFloat(ethers.utils.formatEther(bn))).toLocaleString();
};
export var toETH = function (bn, precision) {
    if (precision === void 0) { precision = 4; }
    return parseFloat(ethers.utils.formatEther(bn)).toFixed(precision);
};
export var assetToFiat = function (num, assetPrice, assetDecimal, precision) {
    if (assetDecimal === void 0) { assetDecimal = 18; }
    if (precision === void 0) { precision = 2; }
    // @ts-ignore
    return (num instanceof BigNumber || num instanceof EthersBigNumber
        ? parseFloat(ethers.utils.formatUnits(num, assetDecimal)) * assetPrice
        : num * assetPrice).toFixed(precision);
};
export var assetToUSD = function (num, assetPrice, assetDecimal, precision) {
    if (assetDecimal === void 0) { assetDecimal = 18; }
    if (precision === void 0) { precision = 2; }
    return currency(assetToFiat(num, assetPrice, assetDecimal, precision)).format();
};
export var ethToUSD = function (num, ethPrice, precision) {
    if (precision === void 0) { precision = 2; }
    return assetToUSD(num, ethPrice, 18, precision);
};
export var formatOption = function (bn) {
    return parseFloat(ethers.utils.formatUnits(bn, 8));
};
export var getWAD = function (decimals) {
    return ethers.utils.parseUnits("1", decimals);
};
export var wmul = function (x, y, decimals) {
    return x
        .mul(y)
        .add(getWAD(decimals).div(ethers.BigNumber.from("2")))
        .div(getWAD(decimals));
};
export var formatAmount = function (n) {
    if (n < 1e4)
        return "" + currency(n, { separator: ",", symbol: "" }).format();
    if (n >= 1e4 && n < 1e6)
        return parseFloat((n / 1e3).toFixed(2)) + "K";
    if (n >= 1e6 && n < 1e9)
        return parseFloat((n / 1e6).toFixed(2)) + "M";
    if (n >= 1e9 && n < 1e12)
        return parseFloat((n / 1e9).toFixed(2)) + "B";
    if (n >= 1e12)
        return parseFloat((n / 1e12).toFixed(2)) + "T";
    return "";
};
export var annualizedPerformance = function (performance) {
    return Math.pow((performance * 0.9 + 1), 52) - 1;
};
export var getRange = function (start, stop, step) {
    var a = [start];
    var b = start;
    while (b < stop) {
        a.push((b += step || 1));
    }
    return a;
};
export var handleSmallNumber = function (n, decimals) {
    if (decimals === void 0) { decimals = 4; }
    var parsedString = n.toFixed(decimals);
    if (n < 1e-6) {
        parsedString = n.toPrecision(1);
    }
    else if (n < 1e-4) {
        parsedString = n.toPrecision(2);
    }
    return parseFloat(parsedString);
};
export var isPracticallyZero = function (num, decimals, marginString) {
    var defaultSignificantDecimals = getDefaultSignificantDecimalsFromAssetDecimals(decimals);
    var _marginString = marginString ||
        (1 / Math.pow(10, defaultSignificantDecimals)).toFixed(defaultSignificantDecimals);
    var margin = ethers.utils.parseUnits(_marginString, decimals);
    return num.lt(margin);
};
//# sourceMappingURL=math.js.map